import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="mt-auto" style={{ backgroundColor: 'var(--gray-900)', color: 'var(--white)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div 
                className="w-14 h-14 rounded-lg flex items-center justify-center" 
                style={{ 
                  background: 'linear-gradient(135deg, var(--marathon-blue) 0%, var(--marathon-red) 100%)'
                }}
              >
                <span className="text-white text-2xl font-black">HT</span>
              </div>
              <div>
                <div className="text-lg font-bold">Hope Tobacco</div>
                <div className="text-sm" style={{ color: 'var(--gray-300)' }}>
                  704 Main St, Hope, Indiana
                </div>
              </div>
            </div>
            <p className="text-sm mb-4" style={{ color: 'var(--gray-300)' }}>
              Marathon Gas • Krispy Krunchy Chicken • Vape & Tobacco<br />
              Your one-stop shop in Hope, Indiana.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1" style={{ color: 'var(--marathon-red)' }} />
                <div className="text-sm" style={{ color: 'var(--gray-300)' }}>
                  704 Main St<br />
                  Hope, Indiana
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={18} style={{ color: 'var(--marathon-red)' }} />
                <a href="tel:8125465780" className="text-sm hover:opacity-80" 
                   style={{ color: 'var(--gray-300)' }}>
                  (812) 546-5780
                </a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Store Hours</h3>
            <div className="space-y-2">
              <div className="flex items-start space-x-3">
                <Clock size={18} className="mt-1" style={{ color: 'var(--marathon-red)' }} />
                <div className="text-sm" style={{ color: 'var(--gray-300)' }}>
                  <div className="font-medium mb-1">Monday - Friday</div>
                  <div>5:00 AM - 11:00 PM</div>
                </div>
              </div>
              <div className="flex items-start space-x-3 ml-9">
                <div className="text-sm" style={{ color: 'var(--gray-300)' }}>
                  <div className="font-medium mb-1">Saturday - Sunday</div>
                  <div>6:00 AM - 11:00 PM</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t mt-8 pt-8" style={{ borderColor: 'var(--gray-700)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm mb-4 md:mb-0" style={{ color: 'var(--gray-400)' }}>
              © 2026 Hope Tobacco. All Rights Reserved.
            </p>
            <p className="text-sm" style={{ color: 'var(--gray-400)' }}>
              704 Main St, Hope, IN • (812) 546-5780
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
